import React, { FunctionComponent } from "react";
import { Claim } from "../../../../types";
import "../DetailView.css";

type ProjectCoordinatorProps = {
  dataSelected: Claim;
};

const ProjectCoordinator: FunctionComponent<ProjectCoordinatorProps> = props => {
  const { dataSelected } = props;

  const getProjectCoordinator = () => {
    if (!dataSelected) {
      return null;
    }

    return (
      <div className="format-section">
        {dataSelected.projectCoordinatorName && (
          <div className="format-fields">
            <div className="label">Name</div>
            <div>
              <div className="value">{dataSelected.projectCoordinatorName}</div>
            </div>
          </div>
        )}
       
        {dataSelected.projectCoordinatorEmail && (
          <div className="format-fields">
            <div className="label">Email</div>
            <div className="value">
              <a href={"mailto:" + dataSelected.projectCoordinatorEmail}>
                {dataSelected.projectCoordinatorEmail}
              </a>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="detail-wrapper">
      <div className="heading">Project Coordinator</div>
      {getProjectCoordinator()}
    </div>
  );
};

export default ProjectCoordinator;
